import React, { memo } from 'react';
import classNames from 'classnames';
import { Map } from 'immutable';

import config from '../../../../config';
import FormGroup from '../../../helpers/FormGroup';
import Textarea from '../../../helpers/Textarea';
import Checkbox from '../../../helpers/Checkbox';
import { Ceo123 } from './Ceo123';
import { CeoAbc } from './CeoAbc';
import { CompanyBuyerCEOTable } from './CompanyBuyerCEOTable';
import { Card } from '../../../helpers/Card';

import style from './style.module.css';

const currentExecutiveLeadsColumnDefs = config.tables.getIn(['companyBuyerCEO', 'currentExecutiveLeads', 'columnDefs']);
const activeProjectsColumnDefs = config.tables.getIn(['companyBuyerCEO', 'activeProjects', 'columnDefs']);

const CompanyBuyerCEOComponent = ({
  canEditData,
  ceo: root = Map(),
  isResearcherUser,
  onDoubleClickRow,
  onGetNextPageDataForCurrentExecutiveLeads,
  onGetNextPageDataForActiveProjects,
  onAddCEOProject,
  onChange,
  onCurrentExecutiveLeadsChange,
  onActiveProjectsChange,
  onGetSuggestion,
}) => {
  const currentExecutiveLeads = root.get('currentExecutiveLeads');
  const activeProjects = root.get('activeProjects');

  return (
    <div className={classNames(style.host, 'full-height flexWrapper')}>
      <Card className={style.filters}>
        <CeoAbc disabled={!canEditData || isResearcherUser} name="ceoAbc" onChange={onChange} root={root} deep />
        <Ceo123 disabled={!canEditData || isResearcherUser} name="ceo123" onChange={onChange} root={root} deep />
        <div className="form-group">
          <Checkbox
            deep="checked"
            disabled={!canEditData || isResearcherUser}
            label="Show Execs"
            name="showExecs"
            onChange={onChange}
            root={root}
          />
        </div>
      </Card>
      <div className={style.body}>
        <div className={style.tables}>
          <CompanyBuyerCEOTable
            canEditData={canEditData}
            columnDefs={currentExecutiveLeadsColumnDefs}
            data={currentExecutiveLeads}
            onChange={onCurrentExecutiveLeadsChange}
            onDoubleClickRow={data => onDoubleClickRow(data, 'executive')}
            onGetNextPageData={onGetNextPageDataForCurrentExecutiveLeads}
            title="Current Executive Leads"
          />
          <CompanyBuyerCEOTable
            canEditData={canEditData}
            columnDefs={activeProjectsColumnDefs}
            data={activeProjects}
            onAddCEOProject={onAddCEOProject}
            onChange={onActiveProjectsChange}
            onDoubleClickRow={data => onDoubleClickRow(data, 'eproject')}
            onGetNextPageData={onGetNextPageDataForActiveProjects}
            onGetSuggestion={onGetSuggestion}
            title="Projects"
            highlightInactive
          />
        </div>
        <Card className={style.notes}>
          <FormGroup>
            <Textarea
              disabled={!canEditData || isResearcherUser}
              label="Notes"
              name="execLeadNotes"
              onChange={onChange}
              placeholder="Notes"
              root={root}
              rows="19"
              deep
              showLabel
            />
          </FormGroup>
        </Card>
      </div>
    </div>
  );
};

/** Company buyer CEO component. */
export const CompanyBuyerCEO = memo(CompanyBuyerCEOComponent);
